import * as React from 'react'

import { INTRODUCTION, } from './constants'

const PreviousButton = ({ tour, onFirstSlide, goToPreviousSlide, goToLastSlideOfIntroduction, }) => {
  if (tour === INTRODUCTION && onFirstSlide) {
    return <span />
  }

  let handleClick = goToPreviousSlide

  if (tour !== INTRODUCTION && onFirstSlide) {
    handleClick = goToLastSlideOfIntroduction
  }

  return (
    <button
      className="quill-button large outlined green focus-on-light"
      onClick={handleClick}
      type="button"
    >Previous</button>
  )
}

export default PreviousButton
